import React from 'react';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import AppointmentSection from '../Section/AppointmentSection';
import AboutSectionStyle2 from '../Section/AboutSection/AboutSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
import { useParams } from "react-router-dom";
import { servicesData } from "../../../src/data/services";


export default function DepartmentDetails() {
  const { departmentId } = useParams();

  const service = servicesData[departmentId];

  if (!service) {
    return <h1>Service Not Found</h1>;
  }
  pageTitle(service.title);
  return (
    <>
      {/* <BreadcrumbStyle2 /> */}
      <Section topMd={135} topLg={100} topXl={100}>
          <AboutSectionStyle2
            title={service.title}
            subTitle={service.subTitle}
            imgUrl={service.imgUrl}
          />
      </Section>

      {/* <Section topMd={170} topLg={145} topXl={90}>
        <FeaturesSectionStyle3
          sectionTitle="Treatments"
          sectionTitleUp="MORE TYPE OF"
          data={featureData}
        />
      </Section> */}
      {/* <Section topMd={200} topLg={150} topXl={100}>
        <TeamSectionStyle3 sectionTitle="Related Doctor" data={doctorData} />
      </Section> */}

      {/* Start Appointment Section */}
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={190}
        bottomLg={145}
        bottomXl={110}
        id="appointment"
      >
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section>
      {/* End Appointment Section */}
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          imgUrl="/images/departments/banner_img_3.png"
          bgUrl="/images/about/footerbanner.png"
          title="Don’t Let Your Smile <br />Take a Backseat!"
          subTitle="Schedule a case with our experienced dental <br />professionals today!"
        />
      </Section>
    </>
  );
}
